import { useNode } from "@craftjs/core";
import React from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  JustifyActiveIcon,
  JustifyIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  PencilActiveIcon,
  PaintIcon,
} from "../../../assets/ui-icons";
import { IconPack } from "../../../assets/icon-pack";

import {
  ColorInput,
  OptionsInput,
  Panel,
  RangeInput,
  SpacerInput,
  Tabs,
  TextInput,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSStarRatingSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    totalStars = 5,
    rating = 3,
    iconSize = 20,
    iconSpacing,
    align,
    suffix,
    prefix,
    activeColor = "#ffa500",
    inactiveColor = "#000000",
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <RangeInput
            resetValue={5}
            min={INPUT_LIMITS["total-star-rating"].min}
            max={INPUT_LIMITS["total-star-rating"].max}
            step={INPUT_LIMITS["total-star-rating"].step}
            label="Total Stars"
            value={totalStars}
            onChange={(val) => {
              setProp((props) => {
                if (val < rating) {
                  props.rating = Number(val);
                }
                props.totalStars = Number(val);
                return props;
              });
            }}
          />
          <RangeInput
            resetValue={3}
            min={INPUT_LIMITS["star-rating"].min}
            max={INPUT_LIMITS["star-rating"].max}
            step={INPUT_LIMITS["star-rating"].step}
            label="Rating"
            value={rating}
            onChange={(val) => {
              setProp((props) => {
                props.rating = val;
              });
            }}
          />
          <RangeInput
            resetValue={20}
            label="Icon Size"
            min={INPUT_LIMITS["cms-font-size"].min}
            max={INPUT_LIMITS["cms-font-size"].max}
            step={INPUT_LIMITS["cms-font-size"].step}
            value={iconSize}
            onChange={(val) => {
              setProp((props) => {
                props.iconSize = val;
              });
            }}
          />
          <RangeInput
            label="Icon Spacing"
            value={iconSpacing}
            onChange={(val) => {
              setProp((props) => {
                props.iconSpacing = val;
              });
            }}
            min={INPUT_LIMITS["cms-gap"].min}
            max={INPUT_LIMITS["cms-gap"].max}
            step={INPUT_LIMITS["cms-gap"].step}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "space-between",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
        <div className="bg-white mt-4 py-2 rounded-[21px] ">
          <Panel label={"Text"}>
            <SpacerInput>
              <TextInput
                minLength={INPUT_LIMITS["star-rating-prefix"].minlength}
                maxLength={INPUT_LIMITS["star-rating-prefix"].maxlength}
                label={"Prefix"}
                value={prefix}
                onChange={(val) => {
                  setProp((props) => {
                    props.prefix = val.target.value;
                  });
                }}
              />
              <TextInput
                minLength={INPUT_LIMITS["star-rating-suffix"].minlength}
                maxLength={INPUT_LIMITS["star-rating-suffix"].maxlength}
                label={"Suffix"}
                value={suffix}
                onChange={(val) => {
                  setProp((props) => {
                    props.suffix = val.target.value;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              resetValue={"#ffa500"}
              value={activeColor}
              onChange={(val) => {
                setProp((props) => {
                  props.activeColor = val;
                });
              }}
              label={"Active"}
            />
            <ColorInput
              resetValue={"#000000"}
              value={inactiveColor}
              onChange={(val) => {
                setProp((props) => {
                  props.inactiveColor = val;
                });
              }}
              label={"inactive"}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];
  return (
    <div className="h-full w-[330px] post-edit-right-sidebar cursor-default p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={"Star Rating"}
            icon={<FontAwesomeIcon size="2xl" icon={faStar} color="#8402E9" />}
          />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
